import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "mr-3 h-6 w-6 shrink-0 text-green-500 [&>svg]:stroke-current [&>svg]:h-full [&>svg]:w-full"
}
const _hoisted_4 = { class: "block truncate" }
const _hoisted_5 = {
  key: 1,
  class: "block truncate text-gray-400"
}
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "mr-3 h-6 w-6 bg-white flex items-center justify-center rounded shrink-0 text-green-500 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5"
}

import { computed, onBeforeMount, ref, watch } from "vue";
import { CheckIcon, ChevronDownIcon } from "@heroicons/vue/20/solid";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";

interface SelectOption {
  id: string;
  name: string;
  icon: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseInputComponent',
  props: {
  context: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const size = computed(() => props.context.size || 'sm');

// ADD THIS: Define the placeholder
const placeholder = ref<string>(
  props.context.placeholder || "Choose an option"
);

const isDisabled = computed(() => Boolean(props.context.disabled));

const listboxButtonClasses = computed(() => {
  const classes: string[] = [
    size.value === 'sm' ? 'py-2' : 'py-3',
    'relative w-full rounded-md pl-3 pr-10 text-left shadow-sm ring-1 ring-inset focus:outline-none focus:ring-2 sm:text-sm sm:leading-6'
  ];

  if (isDisabled.value) {
    classes.push('cursor-not-allowed bg-gray-100 text-gray-400 ring-gray-200 focus:ring-gray-200');
  } else {
    classes.push('cursor-default bg-white text-gray-900');
    classes.push(props.context.state.validationVisible && !props.context.state.valid
      ? 'ring-red-500 focus:ring-red-500'
      : 'ring-gray-300 focus:ring-blue-500');
  }

  return classes;
});

// Computed property for the v-model value (the ID)
const modelValue = computed({
  get() {
    return props.context._value;
  },
  set(newValue) {
    props.context.node.input(newValue);
  },
});

// Computed property for search options
const selectOptions = computed<SelectOption[]>(
  () => props.context.selectOptions || []
);

let selectedOption = ref<SelectOption | null>(null);

// Watch the modelValue (the ID) and update the selected option when the ID changes
watch(modelValue, (newId) => {
  selectedOption.value =
    selectOptions.value.find((o) => o.id === newId) || null;
});

// Watch the selectedOption and update modelValue when it changes
watch(selectedOption, (newOption) => {
  if (newOption) {
    modelValue.value = newOption.id;
  } else {
    modelValue.value = null;
  }
});

// Initialize the selected option based on the initial model value
onBeforeMount(() => {
  console.log("Context: ", props.context)
  const inputValue = props.context._value;
  selectedOption.value =
    selectOptions.value.find((o) => o.id == inputValue) || null;
});

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createBlock(_unref(Listbox), {
    as: "div",
    modelValue: _unref(selectedOption),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedOption) ? (selectedOption).value = $event : selectedOption = $event)),
    disabled: isDisabled.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), {
          class: _normalizeClass(listboxButtonClasses.value)
        }, {
          default: _withCtx(() => [
            (_unref(selectedOption))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (props.context.showIcon)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createVNode(_component_rl_icon, {
                          icon: _unref(selectedOption)?.icon,
                          title: _unref(selectedOption)?.name,
                          "aria-hidden": "true"
                        }, null, 8, ["icon", "title"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(selectedOption)?.name), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(placeholder.value), 1)),
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_unref(ChevronDownIcon), {
                class: "h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListboxOptions), { class: "absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectOptions.value, (selectOption) => {
                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                    as: "template",
                    key: selectOption.id,
                    value: selectOption
                  }, {
                    default: _withCtx(({ active, selected }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
                active ? 'bg-blue-600 text-white' : 'text-gray-900',
                'relative cursor-default select-none py-2 pl-3 pr-9',
              ])
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          (props.context.showIcon)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _createVNode(_component_rl_icon, {
                                  icon: selectOption?.icon,
                                  title: selectOption?.name,
                                  "aria-hidden": "true"
                                }, null, 8, ["icon", "title"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    selected ? 'font-semibold' : 'font-normal',
                    'block truncate',
                  ])
                          }, _toDisplayString(selectOption.name), 3)
                        ]),
                        selected
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([
                  active ? 'text-white' : 'text-blue-600',
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                ])
                            }, [
                              _createVNode(_unref(CheckIcon), {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "disabled"]))
}
}

})